import GlowQuote from '@/components/GlowQuote';
import { ModuleGlowQuote2Fragment, ModuleGlowQuoteFragment } from '@/graphql';
import { getSingle } from '@/lib/typescript-helpers';
import { FC } from 'react';

interface GlowQuoteModuleProps extends PropsWithClassName {
  props: CraftModuleFragment<ModuleGlowQuoteFragment | ModuleGlowQuote2Fragment>;
}

const GlowQuoteModule: FC<GlowQuoteModuleProps> = ({ props, className }) => {
  if (Array.isArray(props)) {
    props = props[0];
  }

  if (!props) return null;

  const quote = getSingle(props.quote);

  if (!quote) return null;

  const image = getSingle(quote.authorPhoto);
  const customer = getSingle(quote.customer);
  const logo = getSingle(customer?.logo);

  return (
    <GlowQuote
      className={className}
      quote={quote.quote ?? ''}
      authorName={quote.authorName ?? ''}
      authorTitle={quote.authorTitle ?? undefined}
      authorImage={
        image
          ? {
            src: image.url!,
            width: image.width ?? 0,
            height: image.height ?? 0,
          }
          : undefined
      }
      logo={
        logo
          ? {
            src: logo.url!,
            width: logo.width ?? 0,
            height: logo.height ?? 0,
            isTaller: customer?.isTaller ?? false,
          }
          : undefined
      }
      companyName={customer?.title ?? undefined}
    />
  );
};

export default GlowQuoteModule;
